export default "__VITE_ASSET__af2caa5b__"